module.exports = __webpack_public_path__ + "img/6_86.a9e74aff.png";